module.exports = __webpack_public_path__ + "static/media/logo_login.5b2e22e6.svg";